(() => {
  // Measure chrome in document coordinates: scrolling must not resize the frame.
  const initGalleryBudget = (scope = document) => {
    scope.querySelectorAll('.theme-main-product').forEach((product) => {
      if (product.dataset.themeGalleryBudgetBound) return;
      const layout = product.querySelector('.theme-main-product__layout');
      if (!layout || !product.querySelector('[data-theme-media-stage]')) return;
      product.dataset.themeGalleryBudgetBound = 'true';
      const desktop = window.matchMedia('(min-width: 960px)');
      const nav = product.querySelector('.theme-main-product__media-continuation');
      const gallery = product.querySelector('.theme-main-product__media');
      const stage = gallery?.querySelector('[data-theme-media-stage]');
      const trigger = stage?.querySelector('[data-theme-media-stage-trigger]');
      const image = trigger?.querySelector('.theme-main-product__media-stage-image');
      const imageClip = trigger?.querySelector('[data-theme-media-image-clip]');
      const imageBorder = trigger?.querySelector('[data-theme-media-image-border]');
      const imageBadge = trigger?.querySelector('.theme-main-product__media-stage-badge');
      const hideImageBorder = () => {
        if (imageBorder) imageBorder.hidden = true;
        if (imageClip) imageClip.style.visibility = 'hidden';
        if (imageBadge) imageBadge.style.visibility = 'hidden';
      };
      const fitImageBorder = () => {
        if (!imageBorder || !image || !trigger) return;
        hideImageBorder();
        if (trigger.hidden || !image.complete || !image.naturalWidth || !image.naturalHeight) return;
        const style = window.getComputedStyle(image);
        const horizontalInset = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        const verticalInset = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        const boxWidth = image.clientWidth - horizontalInset;
        const boxHeight = image.clientHeight - verticalInset;
        if (boxWidth <= 0 || boxHeight <= 0 || style.objectFit !== 'contain') return;
        const scale = Math.min(boxWidth / image.naturalWidth, boxHeight / image.naturalHeight);
        const width = image.naturalWidth * scale;
        const height = image.naturalHeight * scale;
        const position = style.objectPosition.split(/\s+/);
        const offset = (value, space) => {
          if (value === 'center') return space / 2;
          if (value === 'right' || value === 'bottom') return space;
          if (value === 'left' || value === 'top') return 0;
          return value.endsWith('%') ? space * parseFloat(value) / 100 : parseFloat(value) || 0;
        };
        // Position within the image content box; the trigger retains its full focus area.
        const left = image.offsetLeft + image.clientLeft + parseFloat(style.paddingLeft) + offset(position[0], boxWidth - width);
        const top = image.offsetTop + image.clientTop + parseFloat(style.paddingTop) + offset(position[1] || '50%', boxHeight - height);
        Object.assign(imageBorder.style, { left: `${left}px`, top: `${top}px`, width: `${width}px`, height: `${height}px` });
        if (imageClip) {
          // Clip the untransformed parent so image hover zoom cannot enlarge the frame.
          imageClip.style.clipPath = `inset(${top}px calc(100% - ${left + width}px) calc(100% - ${top + height}px) ${left}px)`;
          imageClip.style.visibility = 'visible';
        }
        if (imageBadge) {
          Object.assign(imageBadge.style, {
            right: `calc(100% - ${left + width}px + .75rem)`,
            bottom: `calc(100% - ${top + height}px + .75rem)`,
            visibility: 'visible',
          });
        }
        imageBorder.hidden = false;
      };
      let frame = 0;
      const sync = () => {
        frame = 0;
        if (!product.isConnected) return;
        fitImageBorder();
        if (!desktop.matches) return;
        const values = {
          '--theme-pdp-gallery-top-clearance': `${Math.max(0, layout.getBoundingClientRect().top + window.scrollY)}px`,
          '--theme-pdp-gallery-nav-height': `${nav?.getBoundingClientRect().height || 0}px`,
        };
        Object.entries(values).forEach(([name, value]) => {
          if (product.style.getPropertyValue(name) !== value) product.style.setProperty(name, value);
        });
      };
      const schedule = () => {
        if (!frame) frame = window.requestAnimationFrame(sync);
      };
      const mediaChange = () => { hideImageBorder(); schedule(); };
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
      [document.querySelector('.theme-site-header'), document.querySelector('.theme-announcement'), product.querySelector('.theme-main-product__breadcrumb'), nav, stage].filter(Boolean).forEach((element) => observer?.observe(element, { box: 'border-box' }));
      image?.addEventListener('load', schedule);
      image?.addEventListener('error', hideImageBorder);
      gallery?.addEventListener('theme:media:source-change', mediaChange);
      window.addEventListener('resize', schedule);
      desktop.addEventListener('change', schedule);
      const unload = (event) => {
        if (!event.target.contains(product)) return;
        observer?.disconnect();
        image?.removeEventListener('load', schedule);
        image?.removeEventListener('error', hideImageBorder);
        gallery?.removeEventListener('theme:media:source-change', mediaChange);
        window.removeEventListener('resize', schedule);
        desktop.removeEventListener('change', schedule);
        document.removeEventListener('shopify:section:unload', unload);
        if (frame) window.cancelAnimationFrame(frame);
      };
      document.addEventListener('shopify:section:unload', unload);
      document.fonts?.ready.then(schedule);
      sync();
    });
  };
  // Classify the complete description once at its rendered width. Never truncate
  // or reclassify after the shopper opens it. Without JS all content stays open.
  const init = (scope = document) => {
    initGalleryBudget(scope);
    scope.querySelectorAll('[data-theme-product-details]').forEach((details) => {
      if (details.dataset.themeDetailsBound) return;
      details.dataset.themeDetailsBound = 'true';
      const copy = details.querySelector('[data-theme-product-details-copy]');
      if (!copy) return;
      const long = copy.getBoundingClientRect().height > 480 || Boolean(copy.querySelector('img, video, iframe'));
      if (long) { details.open = false; return; }
      details.dataset.themeDetailsShort = 'true';
      const summary = details.querySelector('summary');
      summary?.addEventListener('click', (event) => event.preventDefault());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
